
<template>
<b-container fluid class="bv-example-cambiocMe">
        <b-img class="logoocMe" :src="logo"></b-img>
        <!-- <b-img class="circulo"  :src="circulo"></b-img>     -->
         <b-card  class="mb-222Me" >
         <b-img class="iconoMe" :src="imgen"></b-img>   
           <b-card-title>
              <div v-if="enviado== false" class="ingreso-al-sistema-prmmmMe poppins-semi-bold-mine-shaft-20px">Mensaje enviado con éxito.</div>
              <div v-if="enviado== true"  class="ingreso-al-sistema-prmmmMe poppins-semi-bold-mine-shaft-20px">El mensaje ha sido <br> reenviado con éxito.</div>
              
              <p class="poppins-normal-tuatara-14px letraMe">Revise su correo electrónico
            <b class="negrita">{{email}}</b>, allí podrá <br>realizar el cambio de su contraseña.<br>  Recuerde revisar su carpeta de SPAM.</p>
            <p class="poppins-normal-tuatara-14px letraMe">Si tiene inconvenientes o no puede <br>acceder a la plataforma, envíe un <br> correo electrónico a <br>sistemas@omnivida.org</p>
            </b-card-title>
         <div @click="regresar()">
            <b-button block class="boton-ingresooMe"  ><label  class="ingresarMe poppins-semi-bold-white-14px">Ir al inicio de sesión</label></b-button>
            </div>
            <div @click="reenviar()">
            <b-button block class="boton-ingresoodMe"  ><label  class="ingresardMe poppins-semi-bold-white-14px">Reenviar mensaje</label></b-button>
            </div>
         </b-card>
</b-container>
  
</template>

<script>
import { RepositoryFactory } from "../repositories/RepositoryFactory";

const resend = RepositoryFactory.get("recoverpass");

export default {
  name: "ModalGeneral",
  components: {},
  
  props: [
    "logo",
    "imgen",
    "circulo",
  ],
  data() {
        return {
            message:"",
            actions:"",
            massageboton:"",
            enviado:false,
            email:"",
        }
    },
    async created() {
          this.email=this.$route.params.email;

    },
     methods: {
         async reenviar(){
             const response = await resend.recoverPasswordEmail({
                "email": this.email
            }).then((respuesta) => {

                if(respuesta.status == 500){
                    return  this.$router.push("/error500");
                }

                 
            }).catch((error) => {
             
         });
        if( this.enviado== false){
            this.enviado= true;
        }
    }, 
    regresar(){
        this.$router.push('/login');
    }
       
    }, 
  
};
</script>

<style>
.circulo{
    position: absolute;
    top: 0;
    left: 25%;
    z-index: 0;
    height: 100%;
}
.letraMe{
        align-self: flex-end;
    letter-spacing: 0;
    line-height: 21px;
    margin-top: 1%;
    text-align: center;
}
.card-body{
    padding: 4%;
}
.bv-example-cambiocMe {
    background-color: var(--blue-violet);
     height: 100vh;
       text-align: center;
    /* background-color: var(--blue-violet);
    margin: 0;
    max-width: 100% !important;
    height: 753px !important;
    text-align: center; */
}
.logoocMe {
     margin: 2% 0 1%;
  width: 20%;
}
.iconoMe {
    margin-top: 3%;
    width: 30%;
}
.negrita{
    font-weight: 600 !important;
}
.ingresardMe{
color: var(--blue-violet) !important;
}
.mb-222Me {
    /* margin-left: 39%;
    padding: 1% 1%;
      line-height: 14px;
      background-color: var(--zircon) !important;
    border-radius: 10px !important;
    margin-top: 3%;
    border-color:transparent !important ;
    z-index: 2; */
    background-color: var(--zircon);
  border-radius: 10px !important;
  padding: 0.8rem;
  max-width: 20rem;
  margin: auto;
  z-index: 1;
    border-color:transparent;
}
.ingreso-al-sistema-prmmmMe { 
  letter-spacing: 0;
  line-height: 25px;
  text-align: center;
  
 
}
.body{
  overflow-x:hidden;
  overflow-y:hidden;
}
.boton-ingresooMe{
    margin-top:2%;
    width:100%;
    background-color: var(--blue-violet) !important;
    border-radius: 10px !important;
    height: 50px;
    border-color:transparent !important ;
}
.boton-ingresooMe:hover{
    background: var(--hover) !important;
}
.boton-ingresoodMe{
    margin-top:7%;
    margin-bottom:0%;
    width:100%;
    background-color: var(--hawkes-blue) !important;
    border: none !important;
    color:var(--blue-violet) !important;
    border-radius: 10px !important;
    height: 50px;
}
.boton-ingresoodMe:hover{
    background: var(--hover-azul) !important;
}
@media (max-width: 669px) {
.logoocMe {
    margin: 6% 0 6%;
  width: 40%;
}
}
/* 
@media (max-width: 1922px) {
.bv-example-cambiocMe {
    height: 969px !important;
}
.mb-222Me {
    margin-left: 41%;
}
}
@media (max-width: 1540px) {
.bv-example-cambiocMe {
    height: 753px !important;
}
.mb-222Me {
   margin-left: 38%;
}
}
@media (max-width: 1370px) {
  .titl{
  margin-top: 10%;
}
.mb-5 {
    margin-bottom: 10% !important;
}
.mb-222Me {
    margin-left: 37.9%;
    max-width: 20rem !important;
    margin-top: 1.3%;
}
.recuperarc {
    width: 350px !important;
    margin-top: 3%;
}
.boton-ingresooMe {
    margin-top: 2%;
    width: 87%;
    height: 50px;
}
.iconoMe {
    margin-top: 0%;
}
.boton-ingresoodMe {
    margin-top: 5%;
    width: 87%;
    height: 50px;
}
.logoocMe {
    width: 13%;
    margin-top: 2%;
}
.ingreso-al-sistema-prmmmMe {
    margin-top: 4%;
    margin-bottom: 4%;
}
.letraMe {
    margin-top: 10px;
}
}
@media (max-width: 1280px) {
    .bv-example-cambiocMe {
    height: 609px !important;
}
.mb-222Me {
    margin-left: 37%;
    margin-top: 2%;
    max-width: 20rem !important;
}
.boton-ingresooMe {
    margin-top: 5%;
    height: 39px !important;
}
.boton-ingresoodMe {
    margin-top: 5%;
    margin-bottom: 0%;
    height: 39px !important;
}

.iconoMe {
    margin-top: -1%;
    width: 28%;
}
.logoocMe {
    margin-top: 2%;
    width: 14%;
}
.ingreso-al-sistema-prmmmMe {
    margin-top: 6%;
    margin-bottom: 6%;
}
}
@media (max-width: 1100px) {
    .bv-example-cambiocMe {
    height: 507px !important;
}
.logoocMe {
    margin-top: 3%;
    width: 14%;
}
.mb-222Me {
    margin-left: 34%;
    margin-top: 2%;
    padding: 0% 0%;
}
.iconoMe {
    margin-top: -1%;
    width: 28%;
}
.ingreso-al-sistema-prmmmMe {
    margin-top: 4%;
    margin-bottom: 4%;
}
.boton-ingresooMe {
    margin-top: -1%;
    width: 88%;
    height: 44px;
}
.boton-ingresoodMe {
    margin-top: 4%;
    margin-bottom: 0%;
    width: 88%;
    height: 44px;
}
} */
</style>